import axios from "axios";
import { Api_url } from "./NETWORKCONSTS";

export function sport_getAll() {
    return axios.get(Api_url.sport.GET_ALL);
}
